// A stored enum as people read it: IN_TRANSIT becomes "In transit".
// Words only: the stored value is never changed. Prefer a module's own label
// map (palletStatusLabel, DELIVERY_STATUS_LABELS ...) when one exists.
export function enumWords(value: string | null | undefined): string {
  if (!value) return ''
  const words = value.replace(/_/g, ' ').toLowerCase()
  return words.charAt(0).toUpperCase() + words.slice(1)
}
